import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Listbox, ListboxLabel, ListboxOption } from "V2.0/common/listbox";
import { Switch, SwitchField } from "V2.0/common/switch";

export default PayloadMappingForm;

function PayloadMappingForm(props) {
  const { formState, errors, updateFormState } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Source Field *</Label>
        <Input
          type="text"
          value={formState.sourceField}
          onChange={(e) => updateFormState("sourceField", e.target.value)}
          invalid={!!errors.sourceField}
        />
        {errors.sourceField && (
          <ErrorMessage>{errors.sourceField}</ErrorMessage>
        )}
      </Field>

      <Field>
        <Label>Target Type</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.targetType}
          onChange={(value) => updateFormState("targetType", value)}
        >
          {[
            { value: "contactField", label: "Contact Field" },
            { value: "attribute", label: "Attribute" },
          ].map((option, idx) => (
            <ListboxOption
              key={idx}
              value={option.value}
            >
              <ListboxLabel>{option.label}</ListboxLabel>
            </ListboxOption>
          ))}
        </Listbox>
      </Field>

      <Field>
        <Label>Target Field *</Label>
        <Input
          type="text"
          value={formState.targetField}
          onChange={(e) => updateFormState("targetField", e.target.value)}
          invalid={!!errors.targetField}
        />
        {errors.targetField && (
          <ErrorMessage>{errors.targetField}</ErrorMessage>
        )}
      </Field>

      <SwitchField>
        <Label>Required</Label>
        <Switch
          checked={formState.isRequired}
          onChange={(isActive) => updateFormState("isRequired", isActive)}
        />
      </SwitchField>

      <Field>
        <Label>Fallback Value</Label>
        <Input
          type="text"
          value={formState.defaultValue}
          onChange={(e) => updateFormState("defaultValue", e.target.value)}
        />
      </Field>
    </div>
  );
}
